export default __webpack_public_path__ + "static/graduationPana-46bc0e32dd5162a1bad1e02a7875e015.png";